import { Snackbar } from '@mui/material'
import { Alert, AlertTitle } from '@mui/material'
import Slide, { SlideProps } from '@mui/material/Slide'
import React from 'react'
import { browserLogger } from 'src/utils/browser-logger'

type TransitionProps = Omit<SlideProps, 'direction'>
function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="up" />
}

type Severity = 'error' | 'warning' | 'info' | 'success'

type Msg = { text: string; title?: string; severity?: Severity; autoHideDuration?: number }
type Listener = (msg: Msg) => void
let listeners: Listener[] = []

export const growl = (msg: string | Msg) => {
  listeners.forEach((l) => l(typeof msg === 'string' ? { text: msg } : msg))
}

export const growlError = (error: Error, title: string = '') => {
  browserLogger.error(title, error)
  growl({
    title: title || 'An expected error has occurred.',
    text: error.message,
    severity: 'error',
    autoHideDuration: 10 * 1000,
  })
}

export const Growler: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [msg, setMsg] = React.useState<Msg>({ text: '' })
  React.useEffect(() => {
    const onAlert = ((e: Msg) => {
      setMsg(e)
      setIsOpen(true)
    }) as any
    listeners = listeners.concat([onAlert])
    return () => {
      listeners = listeners.filter((x) => x !== onAlert)
    }
  })

  if (!isOpen) {
    return null
  }

  const severity = msg.severity ?? 'info'
  const { title } = msg

  return (
    <Snackbar
      open={isOpen}
      TransitionComponent={TransitionUp}
      onClose={() => setIsOpen(false)}
      autoHideDuration={msg.autoHideDuration ?? 2000}>
      <Alert severity={severity}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {msg.text}
      </Alert>
    </Snackbar>
  )
}
